module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), (_vm.approvedPost.influencer) ? _c('v-row', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "4",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return _c('v-card', {
          staticClass: "mx-auto my-12",
          class: ("elevation-" + (hover ? 12 : 2))
        }, [_c('v-list-item', [_c('v-list-item-avatar', {
          attrs: {
            "color": "grey"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(_vm.approvedPost.influencer.profilePicture),
            "alt": "avatar"
          }
        })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "subtitle-1 ma-0"
        }, [_vm._v(_vm._s(_vm.approvedPost.mainPost.campaignName))]), _vm._v(" "), _c('v-list-item-subtitle', {
          staticClass: "caption font-italic"
        }, [_vm._v("\n                    By\n                    "), _c('a', {
          attrs: {
            "href": 'https://instagram.com/' + _vm.approvedPost.influencer.username,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(_vm.approvedPost.influencer.username))])])], 1)], 1), _vm._v(" "), (!_vm.approvedPost.mainPost.images[0]) ? _c('v-img', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "src": "/static/img/upload-post-photo.png",
            "height": "300px"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(_vm.approvedPost.mainPost)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.approvedPost.mainPost.images[0] && !_vm.approvedPost.mainPost.images[0].isvideo) ? _c('v-img', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "src": _vm.approvedPost.mainPost.images[0].url,
            "height": "300px"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(_vm.approvedPost.mainPost)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.approvedPost.mainPost.images[0] && _vm.approvedPost.mainPost.images[0].isvideo) ? _c('video', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "height": "300px",
            "width": "100%"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(_vm.approvedPost.mainPost)
            }
          }
        }, [_c('source', {
          attrs: {
            "src": _vm.approvedPost.mainPost.images[0].url,
            "type": "video/mp4"
          }
        }), _vm._v("\n                Your browser does not support the video tag.\n              ")]) : _vm._e(), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_vm._l((_vm.approvedPost.mainPost.labels), function(label) {
          return _c('v-chip', {
            key: label.text,
            staticClass: "ma-1",
            attrs: {
              "small": "",
              "color": label.color,
              "outlined": label.outlined,
              "dark": label.dark
            },
            on: {
              "click": function($event) {
                return _vm.exec(label.action, _vm.approvedPost.mainPost)
              }
            }
          }, [_vm._v("\n                  " + _vm._s(label.text) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v(_vm._s(label.icon))])], 1)
        }), _vm._v(" "), _c('v-spacer')], 2)], 1)
      }
    }], null, false, 3724328977)
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "proposeDateActions": _vm.showProposeDateAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "postAbuseHistory": false,
      "postReviewApproved": false,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d0260d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/PostDetail.vue
// module id = 2015
// module chunks = 0